import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxUser } from "./dx-user";
let DxKeycloakUser = class DxKeycloakUser extends DxUser {
    get token() {
        return this._token;
    }
    set token(value) {
        this._token = value;
    }
    get tokenExpTime() {
        return this._tokenExpTime;
    }
    set tokenExpTime(value) {
        this._tokenExpTime = value;
    }
    get refreshToken() {
        return this._refreshToken;
    }
    set refreshToken(value) {
        this._refreshToken = value;
    }
    get refreshTokenExpTime() {
        return this._refreshTokenExpTime;
    }
    set refreshTokenExpTime(value) {
        this._refreshTokenExpTime = value;
    }
    get login() {
        return this._login;
    }
    set login(value) {
        this._login = value;
    }
    get firstName() {
        return this._firstName;
    }
    set firstName(value) {
        this._firstName = value;
    }
    get lastName() {
        return this._lastName;
    }
    set lastName(value) {
        this._lastName = value;
    }
    get roles() {
        return this._roles;
    }
    set roles(value) {
        this._roles = value;
    }
    get fullName() {
        // если у пользователя не заданы имя и фамилия, то возвращаем логин
        return (this._firstName && this._lastName) ? (this._firstName + ' ' + this._lastName) : this._login;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "preferred_username", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxKeycloakUser.prototype, "_login", void 0);
tslib_1.__decorate([
    jsonMember({ name: "given_name", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxKeycloakUser.prototype, "_firstName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "family_name", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxKeycloakUser.prototype, "_lastName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "exp", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxKeycloakUser.prototype, "_tokenExpTime", void 0);
DxKeycloakUser = tslib_1.__decorate([
    jsonObject
], DxKeycloakUser);
export { DxKeycloakUser };
